import { createFileRoute, useParams, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

import { ClientExerciseReviewScreen } from '@/features/exercises/components/ClientExerciseReviewScreen';
import { requirePermission } from '@/lib/guards';

const searchSchema = z.object({
  // Set by timeline bubbles so the back link returns to the originating
  // surface — `history` → client detail History tab; `sessions` → sessions
  // workspace. Default (absent) falls back to the client overview.
  returnTab: z.enum(['history', 'sessions']).optional(),
});

export const Route = createFileRoute('/app/clients/$clientId/exercises/$clientExerciseId')({
  beforeLoad: () => {
    requirePermission('engagement:read');
  },
  validateSearch: searchSchema.parse.bind(searchSchema),
  component: ClinicalClientExerciseReviewRoute,
  staticData: { crumb: 'Review' },
});

function ClinicalClientExerciseReviewRoute() {
  const { clientId, clientExerciseId } = useParams({
    from: '/app/clients/$clientId/exercises/$clientExerciseId',
  });
  const { returnTab } = useSearch({ from: '/app/clients/$clientId/exercises/$clientExerciseId' });
  return (
    <ClientExerciseReviewScreen
      clientId={clientId}
      clientExerciseId={clientExerciseId}
      surface="clinical"
      returnTab={returnTab}
    />
  );
}
